import { KeyIcon } from '@heroicons/react/24/outline'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { BackButton, Form, FormSection, Header } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { routes } from 'config/routes'
import { useChangePasswordMutation } from './mutations/useChangePasswordMutation'

const ChangePassword = () => {
	const { t } = useTranslation()
	const params = useParams()
	const {
		handleSubmit,
		register,
		setError,
		formState: { errors }
	} = useForm()

	const { changePasswordMutation, isChangePasswordLoading } = useChangePasswordMutation(setError)

	const onSubmit = (data: any) => {
		changePasswordMutation(data)
	}

	return (
		<>
			<Header
				title={t('Change password')}
				actions={<BackButton to={routes.userEdit(params.id)} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Change password')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={isChangePasswordLoading}>
					<FormSection
						title={t('Password')}
						description={t('Set a new password for this user.')}
						icon={<KeyIcon />}>
						<InputGroup
							id="password"
							type="password"
							label={t('New password')}
							autoComplete="new-password"
							{...register('password')}
							error={(errors as any).password}
						/>
						<InputGroup
							id="password2"
							type="password"
							label={t('Confirm new password')}
							placeholder={t('Repeat the password')}
							autoComplete="new-password"
							{...register('password2')}
							error={(errors as any).password2}
						/>
					</FormSection>
				</Form>
			</div>
		</>
	)
}

export default ChangePassword
